import { call, put, takeLatest } from 'redux-saga/effects';
import type { PayloadAction } from '@reduxjs/toolkit';
import axios from 'axios';
import { BASE_API_URL } from '../../api/config';
import {
  fetchWeeklyIdeasSuccess,
  fetchWeeklyIdeasFailure,
  fetchWeeklyIdeasRequest,
} from '../slices/weeklyIdeasSlice';
import {
  fetchSeasonalIdeasSuccess,
  fetchSeasonalIdeasFailure,
  fetchSeasonalIdeasRequest,
} from '../slices/seasonalIdeasSlice';
import {
  fetchCompetitiveIdeasSuccess,
  fetchCompetitiveIdeasFailure,
  fetchCompetitiveIdeasRequest,
} from '../slices/competitiveIdeasSlice';
import type { WeeklyIdeasResponse, SeasonalIdeasResponse, GeneratedIdeasResponse } from '../../components/campaigns/types';

// Weekly Ideas Saga
function* fetchWeeklyIdeasSaga(action: PayloadAction<string>): Generator<any, void, any> {
  try {
    const restaurantId = action.payload;
    const url = `${BASE_API_URL}/weekly_ideas/${restaurantId}`;
    const response = yield call(axios.get, url);
    const data: WeeklyIdeasResponse = response.data;
    yield put(fetchWeeklyIdeasSuccess(data));
  } catch (error: any) {
    yield put(fetchWeeklyIdeasFailure(error.response?.data?.message || error.message || 'Failed to fetch weekly ideas'));
  }
}

// Seasonal Ideas Saga
function* fetchSeasonalIdeasSaga(action: PayloadAction<string>): Generator<any, void, any> {
  try {
    const restaurantId = action.payload;
    const url = `${BASE_API_URL}/seasonal_suggestions/${restaurantId}`;
    const response = yield call(axios.get, url);
    const data: SeasonalIdeasResponse = response.data;
    yield put(fetchSeasonalIdeasSuccess(data));
  } catch (error: any) {
    yield put(fetchSeasonalIdeasFailure(error.response?.data?.message || error.message || 'Failed to fetch seasonal ideas'));
  }
}

// Competitive Ideas Saga
function* fetchCompetitiveIdeasSaga(action: PayloadAction<string>): Generator<any, void, any> {
  try {
    const restaurantId = action.payload;
    const url = `${BASE_API_URL}/generated_ideas/${restaurantId}`;
    const response = yield call(axios.get, url);
    const data: GeneratedIdeasResponse = response.data;
    yield put(fetchCompetitiveIdeasSuccess(data));
  } catch (error: any) {
    yield put(fetchCompetitiveIdeasFailure(error.response?.data?.message || error.message || 'Failed to fetch competitive ideas'));
  }
}

// Root saga for campaign ideas
export function* campaignIdeasSaga() {
  yield takeLatest(fetchWeeklyIdeasRequest.type, fetchWeeklyIdeasSaga);
  yield takeLatest(fetchSeasonalIdeasRequest.type, fetchSeasonalIdeasSaga);
  yield takeLatest(fetchCompetitiveIdeasRequest.type, fetchCompetitiveIdeasSaga);
}
